"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("../index.scss");
const mobx_react_1 = require("mobx-react");
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const navigation_1 = __importDefault(require("@App/navigation"));
const url_1 = require("@App/helpers/url");
const contexts_1 = require("@App/contexts");
const SaveDraftButton_1 = __importDefault(require("../../Buttons/SaveDraftButton"));
const SubmitWorkButton_1 = __importDefault(require("@Components/Buttons/SubmitWorkButton"));
const DeleteDraftModal_1 = __importDefault(require("@Components/CreateWorkBottomNavs/DeleteDraftModal"));
const react_router_dom_1 = require("react-router-dom");
const work_registration_forms_1 = require("@Const/work-registration-forms");
const ConfirmSubmission_1 = __importDefault(require("../ConfirmSubmission"));
const FormBottomNavBar = (props) => {
    var _a;
    const { backLink, nextLink, isFormStep, isSubmittedStep, isFinishEntityStep, typeWork } = props;
    const { workStore, userStore, popupStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [sidebarIsOpen, setSidebarIsOpen] = (0, react_1.useState)(false);
    const [draftModalOpen, setDraftModalOpen] = (0, react_1.useState)(false);
    const [disableButton, setDisableButton] = (0, react_1.useState)(false);
    const [showSaveDraft, setShowSaveDraft] = (0, react_1.useState)(true);
    const [overclaimConfirmed, setOverclaimConfirmed] = (0, react_1.useState)(false);
    const [submitOverclaimConfirmed, setSubmitOverclaimConfirmed] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const currentRhId = rightsholderStore.currentRightsholderId;
    const isInternal = userStore.isInternal;
    const isValidStep = workStore.wizardStepIsValid;
    (0, react_1.useEffect)(() => {
        if (isSubmittedStep ||
            !(0, url_1.urlHasComponent)('create-work') ||
            (((0, url_1.urlHasComponent)('draft') || (0, url_1.urlHasComponent)('bulk')) && (0, url_1.urlHasComponent)('edit'))) {
            setShowSaveDraft(false);
        }
    }, [isSubmittedStep]);
    const createWork = (isSavingDraftWork) => __awaiter(void 0, void 0, void 0, function* () {
        const draft = workStore.workDraftLocal;
        if (!draft) {
            return;
        }
        setDisableButton(true);
        const creatingWork = Object.assign(Object.assign({}, draft), { id: !isSavingDraftWork ? draft.id : null, isComplete: !isSavingDraftWork });
        yield workStore.createWorkFromNavBar(creatingWork, currentRhId, !draft.isComplete, isSavingDraftWork);
        setDisableButton(false);
        setSidebarIsOpen(false);
    });
    const deleteDraft = (draft) => __awaiter(void 0, void 0, void 0, function* () {
        if (draft.id) {
            yield workStore.deleteDraftRightsHolder(draft.id);
            setDraftModalOpen(false);
            popupStore.setAlertData(`${draft.title} draft has been deleted`, false);
            workStore.setWorkDraftToLocal(work_registration_forms_1.CLEAR_WORK_DRAFT);
            navigate(navigation_1.default.rightholder.registrationDrafts.root(currentRhId));
        }
    });
    const displayOverclaimShareWarning = workStore.isWorkDraftOverclaim() && workStore.isOverclaimAllowed && !overclaimConfirmed;
    const displayOverclaimSubmitWarning = workStore.isWorkDraftOverclaim() && workStore.isOverclaimAllowed && !submitOverclaimConfirmed;
    const confirmationPopupType = displayOverclaimShareWarning || displayOverclaimSubmitWarning ? 'overclaim' : 'submit';
    const onClickConfirmOverclaim = () => {
        if (overclaimConfirmed) {
            setSubmitOverclaimConfirmed(true);
        }
        else {
            setOverclaimConfirmed(true);
            setSidebarIsOpen(false);
            nextLink && navigate(nextLink);
        }
    };
    return (react_1.default.createElement("div", { className: 'next-back-bar-bottom' },
        react_1.default.createElement("div", { className: 'next-back-bar-bottom-content' },
            react_1.default.createElement(Button_1.Button, { mainColor: true, className: 'back', type: 'secondary', typeLink: !!backLink, linkTo: backLink }, "Back"),
            react_1.default.createElement("div", { className: "right" },
                react_1.default.createElement(SaveDraftButton_1.default, { render: showSaveDraft, disabled: isInternal, onClick: () => createWork(true) }),
                isSubmittedStep ? (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', className: 'next', typeLink: true, linkTo: navigation_1.default.rightholder.registrationHistory.root(currentRhId), disabled: !isValidStep }, "Done")) : isFormStep ? (react_1.default.createElement(react_1.default.Fragment, null,
                    typeWork === 'draft' && (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: () => setDraftModalOpen(true) }, "Delete Draft")),
                    react_1.default.createElement(SubmitWorkButton_1.default, { disabled: !isValidStep, onClick: () => setSidebarIsOpen(true) }))) : displayOverclaimShareWarning ? (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', icon: isFinishEntityStep ? undefined : common_1.ICONS.arrow_forward, className: 'next', onClick: () => setSidebarIsOpen(true), disabled: !isValidStep }, "Next")) : (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', className: 'next', icon: isFinishEntityStep ? undefined : common_1.ICONS.arrow_forward, typeLink: !!nextLink, linkTo: nextLink, disabled: !isValidStep }, isFinishEntityStep ? 'Done' : 'Next')))),
        react_1.default.createElement(ConfirmSubmission_1.default, { isInternal: isInternal, disableButton: disableButton, isSideBarOpen: sidebarIsOpen, closeSidebar: () => setSidebarIsOpen(false), createWork: () => createWork(false), step: confirmationPopupType, onClickConfirmOverclaim: onClickConfirmOverclaim }),
        react_1.default.createElement(DeleteDraftModal_1.default, { open: draftModalOpen, closeModal: () => setDraftModalOpen(false), title: (_a = workStore.workDraftLocal) === null || _a === void 0 ? void 0 : _a.title, individual: true, handleDeleteDraft: () => workStore.workDraftLocal && deleteDraft(workStore.workDraftLocal), disabled: isInternal })));
};
exports.default = (0, mobx_react_1.observer)(FormBottomNavBar);
